export const Eventos = {
  HEADER_ABRIR_MENU_LATERAL: 'HEADER_ABRIR_MENU_LATERAL',
  MENU_LATERAL_CATALOGO_ITENS: 'MENU_LATERAL_CATALOGO_ITENS',
  HEADER_ABRIR_MENU_CONTA: 'HEADER_ABRIR_MENU_CONTA',
  MENU_CONTA_ALTERAR_IDIOMA: 'MENU_CONTA_ALTERAR_IDIOMA',
  MENU_CONTA_ALTERAR_TEMA: 'MENU_CONTA_ALTERAR_TEMA',
  ACESSO_BARRA_PESQUISA: 'ACESSO_BARRA_PESQUISA',
  CARD_PLATAFORMA_SELECIONAR_PLATAFORMA:
    'CARD_PLATAFORMA_SELECIONAR_PLATAFORMA',
  MICRO_FRONTEND_BLOQUEADO: 'MICRO_FRONTEND_BLOQUEADO',
  ACESSO_WORKSPACE_EQUIPE: 'ACESSO_WORKSPACE_EQUIPE',
  ACESSO_PAGINA_EQUIPE: 'ACESSO_PAGINA_EQUIPE',
  PRE_ADICIONAR_COMPONENTE_AREA_TRABALHO:
    'PRE_ADICIONAR_COMPONENTE_AREA_TRABALHO',
  INICIO_ADICIONAR_COMPONENTE_AREA_TRABALHO:
    'INICIO_ADICIONAR_COMPONENTE_AREA_TRABALHO',
  PRE_CRIAR_AREA_TRABALHO: 'PRE_CRIAR_AREA_TRABALHO',
  INICIO_CRIAR_AREA_TRABALHO: 'INICIO_CRIAR_AREA_TRABALHO',
  PRE_EDITAR_COMPONENTES_AREA_TRABALHO: 'PRE_EDITAR_COMPONENTES_AREA_TRABALHO',
  INICIO_EDITAR_COMPONENTES_AREA_TRABALHO:
    'INICIO_EDITAR_COMPONENTES_AREA_TRABALHO',
  PRE_COPIAR_AREA_TRABALHO: 'PRE_COPIAR_AREA_TRABALHO',
  INICIO_COPIAR_AREA_TRABALHO: 'INICIO_COPIAR_AREA_TRABALHO',
  MENU_AJUDA: 'MENU_AJUDA',
  CARREGAR_RELATORIO_POWER_BI: 'CARREGAR_RELATORIO_POWER_BI',
  RENDERIZAR_RELATORIO_POWER_BI: 'RENDERIZAR_RELATORIO_POWER_BI',
  EXPORTAR_AREA_TRABALHO: 'EXPORTAR_AREA_TRABALHO',
  DRAWER_SEM_ACESSO: 'DRAWER_SEM_ACESSO',
  ITEM_CATALOGO_RENDERIZADO: 'ITEM_CATALOGO_RENDERIZADO',
  ITEM_CATALOGO_ACESSADO_DIRETO: 'ITEM_CATALOGO_ACESSADO_DIRETO',
  ITEM_CATALOGO_CLICK: 'ITEM_CATALOGO_CLICK',
  LGPD_MODAL_CLOSED: 'LGPD_MODAL_CLOSED'
}
